import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Thème Revolut (sombre) désormais scopé à /crust uniquement.
 * Le reste de Boufi OS utilise le thème boutique (boutique-theme.css via .bshell).
 */
export default function CrustThemeWrapper({ children }) {
  const location = useLocation();

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    if (location.pathname.startsWith('/crust')) {
      body.classList.add('theme-revolut');
      html.classList.add('dark');
      return;
    }
    body.classList.remove('theme-revolut');
    // Hors /crust : le mode clair/sombre suit le choix utilisateur (ThemeContext)
    try {
      const pref = localStorage.getItem('boufi_theme_v2') || 'light';
      html.classList.toggle('dark', pref === 'dark');
    } catch (e) { /* ignore */ }
  }, [location.pathname]);

  return <>{children}</>;
}
